import { render, staticRenderFns } from "./SkeletonTableLoader.vue?vue&type=template&id=3a456ab7&scoped=true&"
import script from "./SkeletonTableLoader.vue?vue&type=script&lang=js&"
export * from "./SkeletonTableLoader.vue?vue&type=script&lang=js&"
import style0 from "./SkeletonTableLoader.vue?vue&type=style&index=0&id=3a456ab7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a456ab7",
  null
  
)

export default component.exports
import {QMarkupTable,QSkeleton} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QMarkupTable,QSkeleton})
